import Loading from "client/common/components/loading/Loading";
import Dialog from "client/common/components/stackables/Dialog";

import styles from "../styles/KlarnaCheckoutDialog.module.less";

const noop = () => undefined;

type KlarnaCheckoutDialogProps = {
  isVisible: boolean;
};

/**
 * A dialog to overlay over the main checkout, this is a special case which
 *  we want to unconditionally display this while klarna checkout is loading.
 * */
const KlarnaCheckoutDialog = ({ isVisible }: KlarnaCheckoutDialogProps) => {
  return (
    <Dialog.Standalone isVisible={isVisible} onClose={noop}>
      <div className={styles.dialog}>
        <h2 className={styles.title}>Placing order with Klarna...</h2>
        <p className={styles.description}>Please wait while we process your payment</p>
        <Loading />
      </div>
    </Dialog.Standalone>
  );
};

export default KlarnaCheckoutDialog;
